import { defineMessages } from 'react-intl';

export default defineMessages({
    descOfProperty: {
        id: 'ml.quoteandbind.minesubscheditem.descOfProperty',
        defaultMessage: 'Description of Property'
    },
    limit: {
        id: 'ml.quoteandbind.minesubscheditem.limit',
        defaultMessage: 'Limit'
    },
    deductible: {
        id: 'ml.quoteandbind.minesubscheditem.deductible',
        defaultMessage: 'Deductible'
    },
    isSchedPropOnInsuredPremis: {
        id: 'ml.quoteandbind.minesubscheditem.isSchedPropOnInsuredPremis',
        defaultMessage: 'Is the scheduled structure located on the primary insured premises?'
    },
    action: {
        id: 'ml.quoteandbind.minesubscheditem.action',
        defaultMessage: 'Action'
    },
    add: {
        id: 'ml.quoteandbind.minesubscheditem.add',
        defaultMessage: 'Add Mine Subsidence Scheduled Private Structure'
    },
    editMineSubsidence: {
        id: 'ml.quoteandbind.minesubscheditem.editMineSubsidence',
        defaultMessage: 'Edit Mine Subsidence Scheduled Private Structure'
    },
    edit: {
        id: 'ml.quoteandbind.minesubscheditem.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.minesubscheditem.remove',
        defaultMessage: 'Remove'
    },
    modalContinue: {
        id: 'ml.quoteandbind.minesubscheditem.modalContinue',
        defaultMessage: 'Continue'
    },
    modalCancel: {
        id: 'ml.quoteandbind.minesubscheditem.modalCancel',
        defaultMessage: 'Cancel'
    }
});
